var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_640_7960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50009 0.0100098C5.27025 0.0100098 2.65158 2.62868 2.65158 5.85852C2.65158 7.13033 3.06853 8.29735 3.76158 9.25309C3.77401 9.276 3.77596 9.30159 3.79009 9.32352L7.6891 15.172C7.86991 15.4433 8.17452 15.606 8.50009 15.606C8.82566 15.606 9.13027 15.4433 9.31108 15.172L13.2101 9.32352C13.2245 9.30159 13.2262 9.276 13.2386 9.25309C13.9317 8.29735 14.3486 7.13033 14.3486 5.85852C14.3486 2.62868 11.7299 0.0100098 8.50009 0.0100098ZM8.50009 7.80802C7.42348 7.80802 6.55059 6.93513 6.55059 5.85852C6.55059 4.78191 7.42348 3.90902 8.50009 3.90902C9.5767 3.90902 10.4496 4.78191 10.4496 5.85852C10.4496 6.93513 9.5767 7.80802 8.50009 7.80802Z",
    fill: "#FDC648"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_7960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.596,
    height: 15.596,
    fill: "white",
    transform: "translate(0.702087 0.0100098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapYellow);
export default __webpack_public_path__ + "static/media/map_yellow.4f315951b36e010b5eb775521142a677.svg";
export { ForwardRef as ReactComponent };